import { useEffect, useState } from "react";
import { CartItem } from "../../components/CartItem";
import { MainButton } from "../../components/MainButton";
import { Menu } from "../../components/Menu";
import { MiniHeader } from "../../components/MiniHeader";
import { AddressMapType, ModalDelivery } from "../../components/ModalDelivery";
import { ModalWithdrawal } from "../../components/ModalWithdrawal";
import {
  centsToFloat,
  floatToCents,
  floatToPercent,
  floatToPrice,
} from "../../functions/price_functions";
import { useOrder } from "../../hooks/useOrder";
import InputMask from "react-input-mask";

import { useAppConfig } from "../../hooks/useAppConfig";
import { Loading } from "../../components/Loading";
import { ConfigType } from "../../contexts/AppConfigContext";
import "./index.css";
import { ModalSellerSave } from "../../components/ModalSellerSave";
import { useSeller } from "../../hooks/useSeller";
import api from "../../services/api";
import {
  MeasureType,
  OrderToSendType,
  OrderType,
  ProductType,
} from "../../contexts/OrderContext";
import { cepNoMask, cpfCnpjNoMask } from "../../functions/mask";
import Swal from "sweetalert2";
import { usePluginspace } from "../../hooks/usePluginspace";
import { useNavigate, useParams } from "react-router-dom";
import { ModalTableSave } from "../../components/ModalTableSave";
import { v4 as uuidv4 } from "uuid";
import { Input } from "../../components/Input/Input";
import { ModalEditFreight } from "../../components/ModalEditFreight";
import useAuth from "../../hooks/useAuth";
import { SellerOrder } from "../SellerOrders";
import { useFoodConfig } from "../../hooks/useFood";
import { PiMagnifyingGlass } from "react-icons/pi";
import { useFaceBookPixel } from "../../hooks/useFacebookPixel";

type ProductCartType = {
  id: number;
  img: string;
  sku: string;
  variation: any;
  name: string;
  price: number;
  unitPrice: number;
  discount: number;
  discountGeral: number;
  promotional_price: number;
  quantity: number;
  code: string;
  sku_info: Array<{
    vendas: number;
    inventory: number;
    minimum_stock: number;
    measures: MeasureType;
  }>;
};

type StoresType = {
  id: number;
  name: string;
  city: string;
  district: string;
  street: string;
  number: string;
  currentBalance: number;
  distance: string;
  locationId?: number;
  sku?: string;
};

type AddressLocationType = {
  cep: string;
  city: string;
  district: string;
  extra: string;
  number: string;
  state: string;
  street: string;
};

type LocationType = {
  id: number;
  name: string;
  code: string;
  status: boolean;
  type: string;
  cep: string;
  address: AddressLocationType | null;
};

type PluginconfigType = {
  id: number;
  pluginspaceId: number;
  plugintypeId: number;
  plugintemplateId: {
    id: number;
    name: string;
  };
  name: string;
  content: any;
};

type ProductTotvsType = {
  id: number;
  chair: string;
  image: string;
  stock: number;
  codFilial: string | null;
  code: string;
  discount: number;
  productName: string;
  hash: string;
  info: string;
  notes: string;
  price: number;
  productSku: string;
  quantity: number;
  unitPrice: number;
  locationId: number;
  variation: Array<{
    grid: string;
    value: string;
  }>;
};

type NinegridMotorConfig = {
  able: number;
  codigoEstabelecimento: number;
  maxMonetary: number;
  maxPercentage: number;
  typeDiscount: number;
};

type ItemEmptyType = {
  id: string;
  locationId: number;
  pluginspaceId: number;
  status: boolean;
  sku: string;
  price: number;
  inventory: number;
  minimumStock: number;
  promotionalPrice: number;
  name: string;
  currentBalance: number;
};

type MapLocationType = {
  longitude: number;
  latitude: number;
};

export function ComandaCart() {
  const navigate = useNavigate();
  const orderContext = useOrder();
  const {
    changeCustomerAdressByCartPage,
    customerAdress,
    getCustomerAdress,
    setType,
    setOrderAddress,
    setLocationId,
  } = useOrder();
  const { trackInitiateCheckout } = useFaceBookPixel();
  const { pluginspace_id } = useParams();
  const {
    getToken,
    pluginspaceData,
    registerAccess,
    getThisPluginspace,
    getLocations,
  } = usePluginspace();
  const [cep, setCep] = useState("");
  const [cepAlarm, setCepAlarm] = useState(false);
  const [findCep, setFindCep] = useState(false);
  const [freightFind, setFreightFind] = useState(0);
  const [typeFreight, setTypeFreight] = useState("withdraw");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { getAppConfig, getSellerAppConfig } = useAppConfig();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);
  const [canWithdraw, setCanWithdraw] = useState(false);

  const [isSeller, setIsSeller] = useState(false);
  const [sellerModalIsOpen, setSellerModalIsOpen] = useState(false);
  const [valueCep, setValueCep] = useState(0);
  const [stores, setStores] = useState<Array<StoresType>>([]);
  const [productStores, setProductStores] = useState<Array<StoresType>>([]);
  const [locations, setLocations] = useState<Array<LocationType>>([]);
  const { getTokenSeller } = useSeller();

  const [order, setOrder] = useState<OrderType>();
  const [orderBackUp, setOrderBackUp] = useState<OrderType>();
  const [total, setTotal] = useState(0);
  const [totalWithoutDiscount, setTotalWithoutDiscount] = useState(0);

  const [hideMenu, setHideMenu] = useState(false);

  const [isCard, setIsCard] = useState(false);
  const [isTable, setIsTable] = useState(false);
  const [isLandmark, setIsLandmark] = useState(false);
  const [isCounter, setIsCounter] = useState(false);
  const [isInternalDelivery, setIsInternalDelivery] = useState(false);
  const [tableModalIsOpen, setTableModalIsOpen] = useState(false);
  const [coupon, setCoupon] = useState("");
  const [totvsVarejoAble, setTotvsVarejoAble] = useState(false);
  const [totvsMotorAble, setTotvsMotorAble] = useState(false);
  const [typePluginspace, setTypePluginspace] = useState("");

  const [ninegridMotorAble, setNinegridMotorAble] = useState(false);
  const [ninegridMotorConfig, setNinegridMotorConfig] =
    useState<NinegridMotorConfig>();

  const [valueWithDraw, setValueWithDraw] = useState(0);

  const [minimumValue, setMinimumValue] = useState(0);

  //descontos
  const [descontoMonetario, setDescontoMonetario] = useState("0");
  const [descontoPercent, setDescontoPercent] = useState("0");

  const [allowDiscountSeller, setAllowDiscountSeller] = useState(false);
  const [maxDiscountSeller, setMaxDiscountSeller] = useState(0);

  const [discountType, setDiscountType] = useState(0);

  //modal de editar frete
  const [modalEditFreight, setModalEditFreight] = useState(false);

  //Tipo de Desconto Geral ou Vendedor
  const [geralDiscount, setGeralDiscount] = useState(false);

  //Limites de desconto monetario e porcentagem

  const [monetaryDiscountMax, setMonetaryDiscountMax] = useState(0);
  const [percentyDiscountMax, setPercentyDiscountMax] = useState(0);

  const [validShift, setValidShift] = useState(true);

  //Se está logado ou não
  const [login, setLogin] = useState(false);

  const [loadingHeader, setLoadingHeader] = useState(true);

  const [position, setPosition] = useState({ latitude: 0, longitude: 0 });

  const [addressMapLocation, setAddressMapLocation] =
    useState<AddressMapType | null>(null);

  const { loginInfo } = useAuth();

  //pediddo auxi para o carrinho do vendedor usado como auxilio
  const [orderSellerAux, setOrderSellerAux] = useState<OrderType>();

  const {
    clearOrder,
    generateDataToSendOrderCard,
    setReceipt,
    setOrderId,
    setOrderIdExt,
  } = useOrder();

  const { setTypeModal, setOpenModal } = useFoodConfig();

  useEffect(() => {
    registerAccess("cart");
    loadAll();
  }, []);

  useEffect(() => {
    !isSeller && loadOrder();
  }, [orderContext]);

  async function findCustomer(cpfOrCnpj: string) {
    const cpfWithouthMask = cpfCnpjNoMask(cpfOrCnpj);

    await api
      .post(
        `/api/customer/filter`,
        {
          cpf: cpfWithouthMask,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          const customerAddresses = response.data.data[0].customerAddresses;
          orderContext.changeCustomerDocument(cpfOrCnpj);
          if (customerAddresses.length > 0) {
            setCep(customerAddresses[0].zipCode);
            orderContext.changeCustomerAdressByCartPage(
              customerAddresses[0].zipCode
            );
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function loadAll() {
    setLoading(true);

    const tk = getTokenSeller();
    if (tk && tk.profile == "seller") {
      setIsSeller(true);
      await getSeller(tk.id);
      await getSellerConfig();
    } else {
      await getConfig();
    }

    await getVerifyShift();
    await verifyTotvs();
    await verifyNinegridProm();

    //usado para verificar se deve ou não criar um carrinho ou atualizar
    await orderContext.getshouldUpdadeCart();
    await orderContext.getGuidCartNew();

    await loadOrder();

    const newOrder = await orderContext.getOrder();
    const newProducts = newOrder.products.filter((product) => !product.orderId);
    newOrder.products = newProducts;
    await orderContext.setProductsOrder(newProducts);
    setOrder(newOrder);
    setOrderSellerAux(newOrder);

    const loc = await getLocations();

    setLocations(loc);

    const pgData = await getThisPluginspace();
    if (pgData && pgData.type) {
      setTypePluginspace(pgData.type);
    }

    if (window.location.search && window.location.search !== "") {
      const guidCart = window.location.search.split("=")[1];
      await getCart(guidCart);

      const customer = await orderContext.getCustomer();

      const documento = await orderContext.getCustomerDocument();
      if (documento) await findCustomer(documento);
    }

    // Setando as flags de tipo de pedido
    setIsLandmark(!!getLandmark());
    setIsInternalDelivery(!!getInternalDelivery());
    setIsCounter(!!getCounterNumber());
    setIsCard(!!getCardNumber());
    setIsTable(!!getTableNumber());

    loginInfo.accessToken != "" ? setLogin(true) : setLogin(false);

    const cA = await getCustomerAdress();

    if (cA) {
      setCep(cA.cep);
    }

    setTimeout(() => {
      setLoading(false);
    }, 0);
  }

  async function verifyTotvs() {
    await api
      .post(
        `/api/pluginconfig/filter`,
        {
          plugintemplateId: 15,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          const configData: PluginconfigType = response.data.data[0];

          if (configData.content.able === "1") {
            setTotvsVarejoAble(true);
            if (configData.content.habilitarMotorPromocao === "1") {
              setTotvsMotorAble(true);
              if (orderContext.order) {
                const productsCart: ProductType[] =
                  orderContext.order?.products.map((product) => {
                    product.promotionalPrice = product.unitPrice;
                    return product;
                  });
                setOrder({
                  products: productsCart,
                });
                await orderContext.changeOrderByGuidCart(
                  productsCart,
                  orderContext
                );
              }
              orderContext.setDiscountGeneral(0);
              await orderContext.totalValueOrder();
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //verificação do motor de promoção ninegrid
  async function verifyNinegridProm() {
    await api
      .post(
        `/api/pluginconfig/filter`,
        {
          plugintemplateId: 107,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          const configData: PluginconfigType = response.data.data[0];
          if (configData.content.able === "1") {
            setNinegridMotorAble(true);
            setNinegridMotorConfig(configData.content);

            setGeralDiscount(
              configData.content.typeDiscount == 0 ? true : false
            );

            setMonetaryDiscountMax(parseFloat(configData.content.maxMonetary));
            setPercentyDiscountMax(
              parseFloat(configData.content.maxPercentage)
            );
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function loadOrder() {
    const totalValues = await orderContext.totalValueOrder(true);
    setTotal(totalValues.total);
    setTotalWithoutDiscount(totalValues.totalWithoutDiscount);
  }

  // Função que retorna o carrinho do cliente (Criado pelo vendedor)
  async function getCart(guid: string) {
    await api
      .get(`/api/customerCart/guid/${guid}`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const order = response.data.data[0];

        const config = await getAppConfig();

        const carrinhoDataCriacao = new Date(order.created);
        const now = new Date(); // Data e hora atuais

        const hour = config
          ? config.content.pdv.sellerCartExpirationTime.split(":")[0]
          : "2";
        const minute = config
          ? config?.content.pdv.sellerCartExpirationTime.split(":")[1]
          : "0";

        const validTimeCart = new Date(
          carrinhoDataCriacao.getFullYear(),
          carrinhoDataCriacao.getMonth(),
          carrinhoDataCriacao.getDate(),
          carrinhoDataCriacao.getHours() + parseInt(hour),
          carrinhoDataCriacao.getMinutes() + parseInt(minute)
        );

        if (now > validTimeCart) {
          Swal.fire({
            icon: "warning",
            titleText: "Carrinho expirado",
            text: "O carrinho do vendedor está expirado. Favor entrar em contato com o seu vendedor",
          });
          return;
        }

        if (
          response.data.data &&
          response.data.data[0] &&
          response.data.data[0].cpfSeller
        ) {
          orderContext.setSellerCpfCnpj(response.data.data[0].cpfSeller);
        }
        orderContext.setCustomer({
          name: order.customerName,
          telephone: order.phoneCustomer,
          cpf: order.cpfCustomer,
        });

        orderContext.setGuidCart(guid);

        orderContext.changeCustomerDocument(order.cpfCustomer);

        let productsCart: any = [];

        if (order.jsonCart.products) {
          productsCart = order.jsonCart.products.map(
            (product: ProductCartType) => {
              const variationFormated: any = {};
              product.variation.map((variation: any) => {
                variationFormated[variation.grid] = variation.value
                  ? variation.value
                  : variation.valor;
              });
              const newProduct: ProductType = {
                id: product.id,
                image: product.img,
                code: product.code,
                locationId: order.locationId,
                name: product.name,
                promotionalPrice: product.promotional_price,
                quantity: product.quantity,
                sku: product.sku,
                stock: product.sku_info[0].inventory,
                unitPrice: product.unitPrice,
                variation: variationFormated,
                pluginspaceHash: pluginspace_id ? pluginspace_id : "",
                outStock: false,
                measures: product.sku_info[0].measures
                  ? product.sku_info[0].measures
                  : null,
              };
              return newProduct;
            }
          );
        } else {
          productsCart = order.jsonCart.map((product: ProductCartType) => {
            const variationFormated: any = {};
            product.variation.map((variation: any) => {
              variationFormated[variation.grid] = variation.value
                ? variation.value
                : variation.valor;
            });
            const newProduct: ProductType = {
              id: product.id,
              image: product.img,
              code: product.code,
              locationId: order.locationId,
              name: product.name,
              promotionalPrice: product.promotional_price,
              quantity: product.quantity,
              sku: product.sku,
              stock: product.sku_info[0].inventory,
              unitPrice: product.unitPrice,
              variation: variationFormated,
              pluginspaceHash: pluginspace_id ? pluginspace_id : "",
              outStock: false,
              measures: product.sku_info[0].measures
                ? product.sku_info[0].measures
                : null,
            };
            return newProduct;
          });
        }

        setOrder({
          products: productsCart,
        });
        await orderContext.changeOrderByGuidCart(productsCart, orderContext);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function getConfig() {
    setLoadingHeader(true);
    const config = await getAppConfig();
    setLoadingHeader(false);
    setMinimumValue(config!.content.pdv.minimumValue);

    setConfig(config);
  }

  async function getSellerConfig() {
    setLoadingHeader(true);
    const config = await getSellerAppConfig();
    setMinimumValue(config!.content.pdv.minimumValue);

    setConfig(config);

    setLoadingHeader(false);
  }

  async function chooseAddress() {
    const purchaseMin = validatePurchaseMin();

    if (!purchaseMin) {
      await Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: `A sua compra não atingiu o valor mínimo de ${floatToPrice(
          minimumValue
        )}`,
      });
      return;
    }
    const locationType = locations.find((loc) => typeFreight === loc.code);
    if (locationType) {
      const storeOutStock: StoresType | undefined = productStores.find(
        (str) => str.locationId === locationType.id && str.currentBalance <= 0
      );
      if (storeOutStock && !(config && config.content.pdv.showOutStock)) {
        const prodFinded: ProductType | undefined = order?.products.find(
          (prod) => prod.sku === storeOutStock.sku
        );
        if (prodFinded) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: `Produto: ${prodFinded.name} sem estoque`,
          });
          return;
        }
      }
    }
    orderContext.setFreight(freightFind);
    setModalIsOpen(true);
  }

  async function findCepDelivery(cepSended?: string) {
    const noMaskCep = cepNoMask(cepSended ? cepSended : cep);

    if (config) {
      const value = config!.content.pdv.withDrawFee
        ? parseFloat(config!.content.pdv.withDrawFee.toString())
        : 0;

      setValueWithDraw(value);
      setFreightFind(value);
    }
    setLoading(true);
    let urlSearchValid = "";
    switch (config?.content.pdv.restrictCep) {
      case "cep":
        urlSearchValid = `/api/zip-code/valid/${noMaskCep}`;
        break;
      case "area":
        urlSearchValid = `/api/delivery/valid/${noMaskCep}`;
        break;
      case "mapa":
        urlSearchValid = `/api/delivery-area/valid/${noMaskCep}`;
        break;
      default:
        urlSearchValid = `/api/zip-code/valid/${noMaskCep}`;
        break;
    }
    await api
      .get(urlSearchValid, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const findedCeps = response.data.data;

        if (findedCeps.length > 0 && findedCeps[0].valor >= 0) {
          setFindCep(true);
          setValueCep(findedCeps[0].valor);
        } else {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "Não foi possível encontrar formas de envio para o CEP",
          });

          setFindCep(false);
          setCanWithdraw(false);
        }
        setLoading(false);
      })
      .catch((err) => {
        setFindCep(false);
        setCanWithdraw(false);
        console.log(err);
        setLoading(false);
      });
  }

  async function validCep(cep: string) {
    return await api
      .get(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`)
      .then((response) => {
        if (response.data.erro) {
          return false;
        }
        return true;
      })
      .catch(() => {
        return false;
      });
  }

  function validatePurchaseMin() {
    return total >= minimumValue ? true : false;
  }

  async function setDiscount() {
    if (discountType == 0) {
      if (parseFloat(descontoMonetario) == 0) {
        const totalValues = await orderContext.totalValueOrder();
        setOrder(orderSellerAux);
        setTotal(totalValues.total);
      } else {
        if (monetaryDiscountMax < parseFloat(descontoMonetario)) {
          Swal.fire({
            icon: "warning",
            titleText: "Desconto inválido",
            text: "Não pode aplicar desconto maior que o configurado",
          });
          await zerarDiscount();
          return;
        }

        const totalValues = await orderContext.totalValueOrder();

        if (totalValues.total - parseFloat(descontoMonetario) <= 0) {
          Swal.fire({
            icon: "warning",
            titleText: "Desconto inválido",
            text: "O desconto não pode ser maior que o valor da compra",
          });
          await zerarDiscount();
          return;
        }
        setTotal(totalValues.total - parseFloat(descontoMonetario));
      }
    } else {
      if (descontoPercent == "0") {
        const totalValues = await orderContext.totalValueOrder();
        setOrder(orderSellerAux);
        setTotal(totalValues.total);
      } else {
        const maxPercentDiscout = geralDiscount
          ? percentyDiscountMax
          : maxDiscountSeller;

        if (maxPercentDiscout < parseFloat(descontoPercent)) {
          Swal.fire({
            icon: "warning",
            titleText: "Desconto inválido",
            text: "Não pode aplicar desconto maior que o configurado",
          });
          await zerarDiscount();
          return;
        }

        const totalValues = await orderContext.totalValueOrder();

        setTotal(totalValues.total);
        const value = (
          (totalValues.total * parseFloat(descontoPercent)) /
          100
        ).toFixed(2);

        if (totalValues.total - parseFloat(value) <= 0) {
          Swal.fire({
            icon: "warning",
            titleText: "Desconto inválido",
            text: "O desconto não pode ser maior que o valor da compra",
          });
          await zerarDiscount();
          return;
        }
        setTotal(totalValues.total - parseFloat(value));
      }
    }
  }

  async function zerarDiscount() {
    const totalValues = await orderContext.totalValueOrder();
    orderContext.setDiscountGeneral(0);

    setTotal(totalValues.total);
    setDescontoMonetario("0");
    setDescontoPercent("0");
  }

  //Caso for um vendedor busque as informações dele
  async function getSeller(id: any) {
    await api
      .get(`/api/users/${id}`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        if (response.status === 200) {
          const data = response.data;
          var regexPattern = new RegExp("true");
          if (data && data.content) {
            const content = JSON.parse(data.content);

            setAllowDiscountSeller(
              content.allow_discount
                ? regexPattern.test(content.allow_discount)
                : false
            );
            setMaxDiscountSeller(
              content.discount_value ? parseFloat(content.discount_value) : 0
            );
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //Nessa Função ocorre a validação do cep e depois a busca pra saber se é valido ou não para a loja
  async function getStores(cepSended?: string, latLng?: MapLocationType) {
    if (order && order.products.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: "Não existem produtos no carrinho",
      });

      return;
    }

    const cepUse = cepSended ? cepSended : cep;
    if (cepUse.includes("_____-___")) {
      return;
    }
    setLoading(true);
    const purchaseMin = validatePurchaseMin();

    if (!purchaseMin) {
      setLoading(false);
      setTimeout(function () {
        Swal.fire({
          icon: "warning",
          title: "Atenção",
          text: `A sua compra não atingiu o valor mínimo de ${floatToPrice(
            minimumValue
          )}`,
        });
      }, 10);
      return;
    }

    const cepOk = cepSended ? true : await validCep(cepUse);
    if (!cepOk) {
      setLoading(false);
      setStores([]);
      Swal.fire({
        icon: "warning",
        title: "CEP inválido!",
        text: "Verifique se o CEP foi digitado corretamente",
      });
      return;
    }
    const noMaskCep = cepNoMask(cepUse);
    const orderSave = await orderContext.getOrder();

    const skus: Array<String> | undefined = orderSave.products.map(
      (prod) => prod.sku
    );
    const pgData = await getThisPluginspace();

    /*
      variavel para verificar se ha a necessidade de pesquisar novamente os 
      estoques do produto. Funciona somente se a pluginSpace for FOOD
  	
    */

    const orderBackUp = await orderContext.getOrderToVerify();

    if (orderBackUp) {
      let shouldSearchAgain = false;
      const skusToVerify: Array<String> | undefined = [];
      const prodsToVerify: Array<ProductType> | undefined = [];

      orderSave.products.forEach((produto) => {
        const productVerify = orderBackUp.products.find(
          (prod) => prod.sku === produto.sku
        );

        if (productVerify) {
          if (produto.quantity > productVerify.quantity) {
            shouldSearchAgain = true;
            skusToVerify.push(produto.sku);
            prodsToVerify.push(produto);
          }
        } else {
          skusToVerify.push(produto.sku);
          prodsToVerify.push(produto);
          shouldSearchAgain = true;
        }
      });

      if (shouldSearchAgain) {
        await api
          .post(
            `/api/variations/skuzipcode`,
            {
              zipcode: noMaskCep,
              skus: skusToVerify ? skusToVerify : [],
              restrictCep: config?.content.pdv.restrictCep
                ? config?.content.pdv.restrictCep
                : "cep",
              noVerifyStock: true,
              locationId: locations.find((el) => el.type == "internal")?.id
                ? locations.find((el) => el.type == "internal")?.id
                : null,
              latLng: latLng ? latLng : null,
            },
            {
              headers: {
                Authorization: `Bearer ${await getToken()}`,
              },
            }
          )
          .then(async (response) => {
            let newStores: Array<StoresType> = [];

            if (!response.data || response.data.success === false) {
              setLoading(false);
              //Fazer um for para mostrar todos os produtos e mostrar na tela
              if (response.data.dataEmpty) {
                const ids = response.data.dataEmpty.map(
                  (prod: any) => prod.sku
                );
                const filtered = response.data.dataEmpty.filter(
                  (prod: any, index: number) =>
                    !ids.includes(prod.sku, index + 1)
                );

                Swal.fire({
                  icon: "warning",
                  title: "Atenção!",
                  text:
                    response.data.dataEmpty &&
                      response.data.dataEmpty.length > 0
                      ? `Produtos: ${filtered
                        .map((u: any) => u.name)
                        .join(", ")} sem estoque`
                      : "Não foi possível encontrar formas de envio para o CEP.",
                });
                const newProducts = orderSave.products.map((produto) => {
                  if (ids.includes(produto.sku)) produto.outStock = true;
                  return produto;
                });
                setOrder({
                  products: newProducts,
                });
              } else {
                const filtered: any = [];
                Swal.fire({
                  icon: "warning",
                  title: "Atenção!",
                  text:
                    response.data.dataEmpty &&
                      response.data.dataEmpty.length > 0
                      ? `Produtos: ${filtered
                        .map((u: any) => u.name)
                        .join(", ")} sem estoque`
                      : "Não foi possível encontrar formas de envio para o CEP.",
                });
              }

              setCanWithdraw(false);
              setStores([]);
              setFindCep(false);
              return;
            }
            //Fazer validação dos produtos desativados no retorno ;

            // comparar sku enviado com os retornados.
            // const ids = response.data.map((prod: any) => prod.sku);
            // const filtered = response.data.filter((prod: any, index: number) => !ids.includes(prod.sku, index + 1));
            // let doesNotexists = skusToVerify.map((skus: any) => {
            // 	const find = filtered.find((prod: any) => prod.sku === skus)

            // 	if (!find) {
            // 		return skus
            // 	}
            // })

            // doesNotexists = doesNotexists.filter((skus: any) => skus !== undefined);

            // if (doesNotexists.length > 0) {

            // 	const produtos = doesNotexists.map((skus: any) => {

            // 		const find = orderSave.products.find((prod: any) => prod.sku === skus)

            // 		return find!.name

            // 	})

            // 	setLoading(false)
            // 	Swal.fire({
            // 		icon: "warning",
            // 		title: 'Atenção!',
            // 		text: (response.data.dataEmpty && response.data.dataEmpty.length > 0) ?
            // 			`Produtos: ${filtered.map((u: any) => u.name).join(', ')} sem estoque`
            // 			: 'Não foi possível encontrar formas de envio para o CEP.'

            // 	});
            // 	let skusEmpty = response.data.dataEmpty.map((item: ItemEmptyType) => item.sku)
            // 	const newProducts = orderSave.products.map(produto => {
            // 		if (skusEmpty.includes(produto.sku)) produto.outStock = true;
            // 		return produto
            // 	})
            // 	setOrder({
            // 		products: newProducts
            // 	})
            // 	setCanWithdraw(false);
            // 	setStores([]);
            // 	setFindCep(false);
            // 	return

            // }

            setProductStores(response.data);
            response.data.map((str: StoresType) => {
              const newStore = {
                id: str.id,
                name: str.name,
                city: str.city,
                district: str.district,
                street: str.street,
                number: str.number,
                distance: str.distance,
                currentBalance: str.currentBalance,
              };
              const findedStore = newStores.find(
                (findStore) =>
                  findStore.name === newStore.name &&
                  findStore.distance === newStore.distance
              );
              if (!findedStore) {
                newStores.push(newStore);
                localStorage.setItem("storeAddress", JSON.stringify(newStore));
              }
            });
            setCanWithdraw(true);
            await findCepAdress(noMaskCep);
            cepSended
              ? await findCepDelivery(cepSended)
              : await findCepDelivery();

            setStores(newStores);
            if (typeFreight === "delivery" && valueCep) {
              setFreightFind(valueCep);
            }
            setLoading(false);

            orderContext.setOrderToVerify(orderSave);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
            Swal.fire({
              icon: "warning",
              title: "Erro!",
              text: "Falha ao buscar CEP",
            });
          });
      } else {
        //verificação la loja, para adicionar como opção
        const localStore = localStorage.getItem("storeAddress");

        if (localStore) {
          const locations = JSON.parse(localStore);

          setStores([locations]);
        }

        setCanWithdraw(true);
        await findCepAdress(noMaskCep);
        cepSended ? await findCepDelivery(cepSended) : await findCepDelivery();
        if (typeFreight === "delivery" && valueCep) {
          setFreightFind(valueCep);
        }
        setLoading(false);
      }
    } else {
      await api
        .post(
          `/api/variations/skuzipcode`,
          {
            zipcode: noMaskCep,
            skus: skus ? skus : [],
            restrictCep: config?.content.pdv.restrictCep
              ? config?.content.pdv.restrictCep
              : "cep",
            noVerifyStock: true,
            locationId: locations.find((el) => el.type == "internal")?.id
              ? locations.find((el) => el.type == "internal")?.id
              : null,
            latLng: latLng ? latLng : null,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          let newStores: Array<StoresType> = [];

          if (!response.data || response.data.success === false) {
            setLoading(false);
            //Fazer um for para mostrar todos os produtos e mostrar na tela
            if (response.data.dataEmpty) {
              const ids = response.data.dataEmpty.map((prod: any) => prod.sku);
              const filtered = response.data.dataEmpty.filter(
                (prod: any, index: number) => !ids.includes(prod.sku, index + 1)
              );

              Swal.fire({
                icon: "warning",
                title: "Atenção!",
                text:
                  response.data.dataEmpty && response.data.dataEmpty.length > 0
                    ? `Produtos: ${filtered
                      .map((u: any) => u.name)
                      .join(", ")} sem estoque`
                    : "Não foi possível encontrar formas de envio para o CEP.",
              });
              const newProducts = orderSave.products.map((produto) => {
                if (ids.includes(produto.sku)) produto.outStock = true;
                return produto;
              });
              setOrder({
                products: newProducts,
              });
            } else {
              const filtered: any = [];
              Swal.fire({
                icon: "warning",
                title: "Atenção!",
                text:
                  response.data.dataEmpty && response.data.dataEmpty.length > 0
                    ? `Produtos: ${filtered
                      .map((u: any) => u.name)
                      .join(", ")} sem estoque`
                    : "Não foi possível encontrar formas de envio para o CEP.",
              });
            }

            setCanWithdraw(false);
            setStores([]);
            setFindCep(false);
            return;
          }
          //Fazer validação dos produtos desativados no retorno ;

          // comparar sku enviado com os retornados.
          // const ids = response.data.map((prod: any) => prod.sku);
          // const filtered = response.data.filter((prod: any, index: number) => !ids.includes(prod.sku, index + 1));
          // let doesNotexists = skus.map((skus: any) => {
          // 	const find = filtered.find((prod: any) => prod.sku === skus)

          // 	if (!find) {
          // 		return skus
          // 	}
          // })

          // doesNotexists = doesNotexists.filter((skus: any) => skus !== undefined);

          // if (doesNotexists.length > 0) {

          // 	const produtos = doesNotexists.map((skus: any) => {

          // 		const find = orderSave.products.find((prod: any) => prod.sku === skus)

          // 		return find!.name

          // 	})

          // 	setLoading(false)
          // 	Swal.fire({
          // 		icon: "warning",
          // 		title: 'Atenção!',
          // 		text: (response.data.dataEmpty && response.data.dataEmpty.length > 0) ?
          // 			`Produtos: ${filtered.map((u: any) => u.name).join(', ')} sem estoque`
          // 			: 'Não foi possível encontrar formas de envio para o CEP.'

          // 	});
          // 	let skusEmpty = response.data.dataEmpty.map((item: ItemEmptyType) => item.sku)
          // 	const newProducts: ProductType[] = orderSave.products.map(produto => {
          // 		if (skusEmpty.includes(produto.sku)) produto.outStock = true;
          // 		return produto
          // 	})

          // 	setOrder({
          // 		products: newProducts
          // 	})

          // 	setCanWithdraw(false);
          // 	setStores([]);
          // 	setFindCep(false);
          // 	return

          // }

          setProductStores(response.data);
          response.data.forEach((str: StoresType) => {
            const newStore = {
              id: str.id,
              name: str.name,
              city: str.city,
              district: str.district,
              street: str.street,
              number: str.number,
              distance: str.distance,
              currentBalance: str.currentBalance,
            };
            const findedStore = newStores.find(
              (findStore) =>
                findStore.name === newStore.name &&
                findStore.distance === newStore.distance
            );
            if (!findedStore) {
              localStorage.setItem("storeAddress", JSON.stringify(newStore));
              newStores.push(newStore);
            }
          });
          setCanWithdraw(true);
          await findCepAdress(noMaskCep);
          cepSended
            ? await findCepDelivery(cepSended)
            : await findCepDelivery();

          setStores(newStores);
          if (typeFreight === "delivery" && valueCep) {
            setFreightFind(valueCep);
          }
          setLoading(false);

          orderContext.setOrderToVerify(orderSave);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          Swal.fire({
            icon: "warning",
            title: "Erro!",
            text: "Falha ao buscar CEP",
          });
        });
    }

    if (isSeller) {
      await setDiscount();
    }
  }

  // função movida para a PluginSpaceContex  07/12/2023 - Bernnardo Pestana

  /*
  async function getLocations() {

    //Validação das localizações da loja para que busque do localStorage.
    //Caso exista não precisa buscar novamente, mais indicado para o FOOD

    //Essa função vai ser replicada para o ModalWithDrawl e ModalDelivery,
    //uma vez que fazem a pesquisa da location para recuperar alguns dados.


    const locationsInLocalStore = localStorage.getItem('locations');

    if (locationsInLocalStore) {

      const newLocation = JSON.parse(locationsInLocalStore)

      setLocations(
        newLocation
      );

    } else {
      await api
        .get(`/api/location`, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        })
        .then(async (response) => {
          const newLocations = response.data.data.map(
            (location: LocationType) => ({
              id: location.id,
              name: location.name,
              code: location.code,
              status: location.status,
              type: location.type,
              cep: location.cep,
              address: location.address
            })
          );
          const newLocationsFiltered = newLocations.filter(
            (loc: LocationType) => loc.status === true
          )
          setLocations(
            newLocationsFiltered
          );

          localStorage.setItem('locations', JSON.stringify(newLocationsFiltered));
        })
        .catch((err) => {
          console.log(err);
        });
    }

  }
*/

  const getLandmark = () => {
    const landmark = localStorage.getItem("landmark_synkar");
    if (landmark) {
      const landmarkItem = JSON.parse(window.atob(landmark));
      return landmarkItem.interval;
    } else {
      return null;
    }
  };

  const getInternalDelivery = () => {
    const internalDelivery = localStorage.getItem("internal_number");
    return internalDelivery ? true : null;
  };

  const getCardNumber = () => {
    const cardNumber = localStorage.getItem("card_number");
    return cardNumber ? cardNumber : null;
  };

  const getCounterNumber = () => {
    const counterNumber = localStorage.getItem("counter_number");
    return counterNumber ? counterNumber : null;
  };

  const getTableNumber = () => {
    const tableNumber = localStorage.getItem("table_number");
    return tableNumber ? tableNumber : null;
  };

  function openModalToSendOrderFood() {
    setTypeModal("Enviar pedido");
    trackInitiateCheckout();
    setOpenModal(true);
  }

  // função mudada para o modal do Food
  const sendTableOrder = async () => {
    setLoading(true);
    const orderData: OrderToSendType | undefined =
      await generateDataToSendOrderCard(
        {
          name: "",
          cpf: "",
          telephone: "",
          acceptTermDate: new Date(),
        },
        "",
        uuidv4(),
        false
      );
    const tableNumber = getTableNumber();
    if (orderData && tableNumber) {
      const result = await api
        .post(
          "/api/orders/send-food-order",
          { ...orderData, tableNumber: atob(tableNumber) },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            return err.response.data;
          }
          return null;
        });
      setLoading(false);
      if (result && result.success === true) {
        setOrderId(result.dados.orderId);
        setOrderIdExt(result.dados.orderidExt);
        clearOrder();
        Swal.fire({
          icon: "success",
          title: "Pedido enviado com sucesso!",
        });
        navigate(`/${pluginspace_id}/products`, { replace: true });
      } else {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text:
            result && result.message
              ? result.message
              : "Não foi possível enviar o pedido",
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível enviar o pedido",
      });
    }
  };

  const continueSynkar = async () => {
    const purchaseMin = validatePurchaseMin();

    if (!purchaseMin) {
      await Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: `A sua compra não atingiu o valor mínimo de ${floatToPrice(
          minimumValue
        )}`,
      });
      return;
    }
    setLoading(true);
    const locationSynkar = locations.find((loc) => loc.code === "synkar");
    const locationStore = locations.find((loc) => loc.type === "address");

    if (locationSynkar && locationStore) {
      await calculateDiscount();
      setLoading(false);
      setType("synkar");

      setOrderAddress({
        address: locationStore.address ? locationStore.address.street : "",
        cep: locationStore.cep,
        state: locationStore.address ? locationStore.address.state : "",
        city: locationStore.address ? locationStore.address.city : "",
        complement: locationStore.address ? locationStore.address.extra : "",
        district: locationStore.address ? locationStore.address.district : "",
        name: locationStore.name,
        number: locationStore.address ? locationStore.address.number : "",
        reference: "",
      });
      trackInitiateCheckout();
      setLocationId(locationSynkar.id);
      navigate(`/${pluginspace_id}/customer`);
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível encontrar a modalidade de automação",
      });
    }
  };

  const continueCounter = async () => {
    const purchaseMin = validatePurchaseMin();

    if (!purchaseMin) {
      await Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: `A sua compra não atingiu o valor mínimo de ${floatToPrice(
          minimumValue
        )}`,
      });
      return;
    }
    setLoading(true);
    const locationCounter = locations.find((loc) => loc.code === "counter");
    const locationStore = locations.find((loc) => loc.type === "address");

    if (locationCounter && locationStore) {
      await calculateDiscount();
      setLoading(false);
      setType("counter");

      setOrderAddress({
        address: locationStore.address ? locationStore.address.street : "",
        cep: locationStore.cep,
        state: locationStore.address ? locationStore.address.state : "",
        city: locationStore.address ? locationStore.address.city : "",
        complement: locationStore.address ? locationStore.address.extra : "",
        district: locationStore.address ? locationStore.address.district : "",
        name: locationStore.name,
        number: locationStore.address ? locationStore.address.number : "",
        reference: "",
      });
      trackInitiateCheckout();
      setLocationId(locationCounter.id);
      navigate(`/${pluginspace_id}/customer`);
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível encontrar a modalidade de automação",
      });
    }
  };

  const continueInternalDelivery = async () => {
    const purchaseMin = validatePurchaseMin();

    if (!purchaseMin) {
      await Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: `A sua compra não atingiu o valor mínimo de ${floatToPrice(
          minimumValue
        )}`,
      });
      return;
    }
    setLoading(true);
    const locationInternalDelivery = locations.find(
      (loc) => loc.code === "internal-delivery"
    );
    const locationStore = locations.find((loc) => loc.type === "address");
    const internalDeliveryNumber = localStorage.getItem("internal_number");
    const internalDeliveryName = localStorage.getItem("internal_name");
    if (locationInternalDelivery && locationStore && internalDeliveryNumber) {
      await calculateDiscount();
      setLoading(false);
      setType("internal-delivery");

      setOrderAddress({
        address: locationStore.address ? locationStore.address.street : "",
        cep: locationStore.cep,
        state: locationStore.address ? locationStore.address.state : "",
        city: locationStore.address ? locationStore.address.city : "",
        complement: internalDeliveryName
          ? `${window.atob(internalDeliveryName)} ${window.atob(
            internalDeliveryNumber
          )}`
          : window.atob(internalDeliveryNumber),
        district: locationStore.address ? locationStore.address.district : "",
        name: `${locationStore.name}`,
        number: locationStore.address ? locationStore.address.number : "",
        reference: "",
      });
      setLocationId(locationInternalDelivery.id);
      trackInitiateCheckout();
      navigate(`/${pluginspace_id}/customer`);
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível encontrar a modalidade de entrega interna",
      });
    }
  };

  async function calculateDiscount() {
    if (totvsVarejoAble) {
      setLoading(true);
      const products = order?.products.map((product) => ({
        hash: window.btoa(product.code),
        id: product.id,
        productName: product.name,
        image: product.image,
        stock: product.stock,
        code: product.code,
        locationId: product.locationId,
        quantity: product.quantity,
        discount:
          product.promotionalPrice !== product.unitPrice &&
            product.promotionalPrice !== 0
            ? parseInt(
              ((product.unitPrice - product.promotionalPrice) * 100).toFixed(
                0
              )
            )
            : 0,
        price:
          product.promotionalPrice !== product.unitPrice &&
            product.promotionalPrice !== 0
            ? parseInt(
              ((product.unitPrice - product.promotionalPrice) * 100).toFixed(
                0
              )
            )
            : parseInt((product.unitPrice * 100).toFixed(0)),
        unitPrice: parseInt((product.unitPrice * 100).toFixed(0)),
        codFilial: pluginspaceData?.id,
        info: "",
        chair: "",
        notes: "",
        productSku: product.sku,
        variation: Object.entries(product.variation).map((obj) => ({
          grid: obj[0],
          value: obj[1],
        })),
      }));
      await api
        .post(
          "/api/totvsPromotionEngine/calculatePromotion",
          {
            "couponPromotionalCode--": coupon,
            discountGeneral: 0.0,
            products,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          setLoading(false);
          if (response.data) {
            const newProducts: Array<ProductType> = response.data.products.map(
              (product: ProductTotvsType) => {
                let objVar: any = {};
                product.variation.forEach((variation) => {
                  objVar[variation.grid] = variation.value;
                });
                return {
                  id: product.id,
                  name: product.productName,
                  image: product.image,
                  unitPrice: parseFloat((product.unitPrice / 100).toFixed(2)),
                  promotionalPrice: product.price
                    ? parseFloat(
                      ((product.unitPrice - product.discount) / 100).toFixed(
                        2
                      )
                    )
                    : parseFloat(
                      ((product.unitPrice - product.discount) / 100).toFixed(
                        2
                      )
                    ),
                  quantity: product.quantity,
                  stock: product.stock,
                  sku: product.productSku,
                  variation: objVar,
                  code: product.code,
                  locationId: product.locationId,
                  pluginspaceHash: pluginspace_id,
                };
              }
            );
            await orderContext.changeOrderByGuidCart(newProducts, orderContext);
            orderContext.setDiscountGeneral(
              response.data.totalAmountDiscount
                ? response.data.totalAmountDiscount
                : 0
            );
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          return null;
        });
    }
  }

  async function calculateNinegridDiscount() {
    if (
      ninegridMotorAble &&
      allowDiscountSeller &&
      ninegridMotorConfig &&
      (parseFloat(descontoPercent) > 0 || parseFloat(descontoMonetario) > 0)
    ) {
      //verificar os valores do desconto se são menores ou iguais aos limites impostos
      // Tipo Desconto = 0 money | 1 - percentage
      // token do Vendedor para validar seu limite de desconto

      if (total <= 0) {
        Swal.fire({
          icon: "warning",
          title: "Desconto inválido!",
          text: "Desconto maior que o valor da venda.",
        }).then((result) => {
          setModalIsOpen(false);
        });
        setModalIsOpen(false);

        await zerarDiscount();
        await loadOrder();
        await orderContext.setDiscountGeneral(0);
        return false;
      }

      if (discountType == 0) {
        if (ninegridMotorConfig.maxMonetary < parseFloat(descontoMonetario)) {
          setLoading(false);
          setModalIsOpen(false);

          Swal.fire({
            icon: "warning",
            title: "Desconto inválido!",
            text: `Seu limite máximo de desconto é de ${floatToPrice(
              parseFloat(ninegridMotorConfig!.maxMonetary.toString())
            )} para essa venda`,
          }).then(() => setModalIsOpen(false));

          await zerarDiscount();
          await loadOrder();
          await orderContext.setDiscountGeneral(0);
          return false;
        }
      } else {
        const limit = geralDiscount
          ? ninegridMotorConfig!.maxPercentage < parseFloat(descontoPercent)
          : maxDiscountSeller < parseFloat(descontoPercent);

        const value = geralDiscount
          ? ninegridMotorConfig!.maxPercentage
          : maxDiscountSeller;

        if (limit) {
          setLoading(false);
          setModalIsOpen(false);
          Swal.fire({
            icon: "warning",
            title: "Desconto inválido!",
            text: `Seu limite máximo de desconto é de ${floatToPercent(
              value
            )} para essa venda`,
          }).then(() => setModalIsOpen(false));

          await zerarDiscount();
          await loadOrder();
          await orderContext.setDiscountGeneral(0);

          return false;
        }
      }

      setLoading(true);
      const tk = getTokenSeller();

      const newOrder = await orderContext.getOrder();

      const products = newOrder.products.map((product) => ({
        hash: window.btoa(product.code),
        id: product.id,
        productName: product.name,
        image: product.image,
        stock: product.stock,
        code: product.code,
        locationId: product.locationId,
        quantity: product.quantity,
        //discount: (product.promotionalPrice !== product.unitPrice && product.promotionalPrice !== 0) ? parseInt(((product.unitPrice - product.promotionalPrice) * 100).toFixed(0)) : 0,
        price:
          product.promotionalPrice !== product.unitPrice &&
            product.promotionalPrice !== 0
            ? parseInt((product.promotionalPrice * 100).toFixed(0))
            : parseInt((product.unitPrice * 100).toFixed(0)),
        unitPrice:
          product.promotionalPrice !== product.unitPrice &&
            product.promotionalPrice !== 0
            ? parseInt((product.promotionalPrice * 100).toFixed(0))
            : parseInt((product.unitPrice * 100).toFixed(0)),
        //unitPrice: parseInt((product.unitPrice * 100).toFixed(0)),
        codFilial: pluginspaceData?.id,
        discountValue: 0,
        discountPercentageValue: 0,
        info: "",
        chair: "",
        notes: "",
        productSku: product.sku,
        measures: product.measures,
        variation: Object.entries(product.variation).map((obj) => ({
          grid: obj[0],
          value: obj[1],
        })),
      }));

      const payload = {
        couponPromotionalCode: "",
        totalAmountDiscount: parseFloat(descontoMonetario),
        percentageDiscountTotalAmount: parseFloat(descontoPercent),
        discountGeneral: 0,
        products: products,
      };
      await api
        .post("/api/discount-enginer/calcdiscount", payload, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        })
        .then(async (response) => {
          setLoading(false);
          if (response.data) {
            const data = response.data.data.data;
            const newProducts: Array<ProductType> = data.products.map(
              (product: any) => {
                let objVar: any = {};
                product.variation.forEach((variation: any) => {
                  objVar[variation.grid] = variation.value;
                });
                return {
                  id: product.id,
                  name: product.productName,
                  image: product.image,
                  unitPrice: parseFloat((product.unitPrice / 100).toFixed(2)),
                  promotionalPrice: product.price
                    ? parseFloat(
                      ((product.unitPrice - product.discount) / 100).toFixed(
                        2
                      )
                    )
                    : parseFloat(
                      ((product.unitPrice - product.discount) / 100).toFixed(
                        2
                      )
                    ),
                  quantity: product.quantity,
                  stock: product.stock,
                  sku: product.productSku,
                  measures: product.measures,
                  variation: objVar,
                  code: product.code,
                  locationId: product.locationId,
                  pluginspaceHash: pluginspace_id,
                };
              }
            );

            /*await orderContext.changeOrderByGuidCart(
              newProducts,
              orderContext
            );*/
            await orderContext.setOrderWithDiscount(newProducts);

            setOrder({
              products: newProducts,
            });

            await orderContext.setDiscountGeneral(
              data.totalAmountDiscount ? data.totalAmountDiscount : 0
            );

            if (config?.content.pdv.sellerCheckout == 1) {
              setSellerModalIsOpen(true);
            } else {
              await chooseAddress();
            }
          }
        })
        .catch((err) => {
          setLoading(false);

          Swal.fire({
            icon: "warning",
            title: "Desconto não aplicado!",
            text: "Descontos não aplicados, deseja continuar mesmo assim",

            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: "Sim, continuar!",
            cancelButtonText: "Não, cancelar!",
          }).then(async (result) => {
            if (result.isConfirmed) {
              const newOrder = await orderContext.getOrder();
              await orderContext.setOrderWithDiscount(newOrder.products);
              if (config?.content.pdv.sellerCheckout == 1) {
                setSellerModalIsOpen(true);
              } else {
                await chooseAddress();
              }
            }
          });

          console.log(err);
          return null;
        });
      setLoading(false);
    } else {
      const newOrder = await orderContext.getOrder();
      await orderContext.setOrderWithDiscount(newOrder.products);

      if (config?.content.pdv.sellerCheckout == 1) {
        setSellerModalIsOpen(true);
      } else {
        await chooseAddress();
      }
    }
  }

  //Pesquisar o cep digitado e repassar para a função de salvar endereço do cliente no localStorage
  async function findCepAdress(cep2: string) {
    return await api
      .get(`https://viacep.com.br/ws/${cep2.replace("-", "")}/json/`)
      .then((response) => {
        if (response.data.erro) {
          Swal.fire({
            icon: "warning",
            title: "CEP inválido!",
            text: "Verifique se o CEP foi digitado corretamente.",
          });
          return false;
        } else {
          changeCustomerAdressByCartPage({
            address: response.data.bairro,
            cep: cep2.replace("-", ""),
            city: response.data.localidade,
            complement: response.data.cep,
            district: response.data.logradouro,
            name: "",
            number: "",
            reference: "",
            telephone: "",
            state: response.data.uf,
            ibge: response.data.ibge,
          });
          setCep(response.data.cep);

          return true;
        }
      })
      .catch(() => {
        Swal.fire({
          icon: "warning",
          title: "CEP inválido!",
          text: "Verifique se o CEP foi digitado corretamente.",
        });
        return false;
      });
  }

  async function getVerifyShift() {
    try {
      const pgData = await getThisPluginspace();
      const response = await api.post(
        `api/location-operation/verify`,
        {},
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      );
      if (pgData && pgData.type === "food") {
        setValidShift(response.data && response.data.success);
      } else {
        setValidShift(true);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const createCart = async () => {
    if (orderContext.shouldUpdadeCart) {
      const link = `${window.location.origin}/${window.location.pathname.split("/")[1]
        }/cart`;

      if (!orderContext.guidCart) {
        //create
        const jsonCart = {
          products: order!.products,
          address: {},
          type: typeFreight,
          freight: freightFind,
          totalDiscount: 0,
        };

        const objCustomerCart = {
          customerName: "",
          cpfCustomer: "",
          phoneCustomer: "",
          cpfSeller: orderContext.cpfVendor,
          jsonCart: jsonCart,
          locationId: order!.products[0].locationId,
          urlcart: link + "?cart=",
        };
        await api
          .post(`/api/customerCart`, objCustomerCart, {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          })
          .then(async (response) => {
            console.log(response);

            if (response.status === 201) {
              const data = response.data.dados;
              orderContext.setGuidCart(data.guid);

              orderContext.setGuidCartNew(data.guid);
            } else {
              setLoading(false);
              Swal.fire({
                icon: "error",
                title: "Erro ao criar carrinho",
              });
            }
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Erro ao criar carrinho",
            });
            console.log(err);
            setLoading(false);
          });

        return;
      }
    }

    return;
  };

  const verifyStock = async () => {
    setLoading(true);
    const locationType = locations.find((loc) => typeFreight === loc.code);
    let success = true;
    if (locationType && !(config && config.content.pdv.showOutStock)) {
      const orderSave = await orderContext.getOrder();
      await api
        .post(
          `/api/variations/sku-inventory`,
          {
            skus:
              orderSave && orderSave.products
                ? orderSave.products.map((p) => p.sku)
                : [],
            locationId: locationType.id,
            status: true,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          if (response.data && response.data.success && response.data.data) {
            const itemsSku = response.data.data.filter(
              (product: any) => product.inventory <= 0
            );
            if (itemsSku.length > 0) {
              let skusEmpty = itemsSku.map((item: ItemEmptyType) => item.sku);
              const newProducts = orderSave.products.map((produto) => {
                if (skusEmpty.includes(produto.sku)) produto.outStock = true;
                return produto;
              });
              Swal.fire({
                icon: "warning",
                title: "Atenção!",
                text: `Produtos: ${itemsSku
                  .map((u: any) => u.name)
                  .join(", ")} sem estoque`,
              });
              setOrder({
                products: newProducts,
              });
              success = false;
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Erro!",
              text: `Falha ao recuperar estoque de produtos`,
            });
            success = false;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Erro!",
            text: `Falha ao recuperar estoque de produtos`,
          });
          success = false;
        });
    }
    setLoading(false);
    return success;
  };

  const getUserPosition = async () => {
    setLoading(true);
    await navigator.geolocation.getCurrentPosition(
      async (positionGet) => {
        setPosition({
          latitude: positionGet.coords.latitude,
          longitude: positionGet.coords.longitude,
        });
        setLoading(true);
        await api
          .post(
            `/api/maps/cep-by-geolocation`,
            {
              latitude: positionGet.coords.latitude,
              longitude: positionGet.coords.longitude,
            },
            {
              headers: {
                Authorization: `Bearer ${await getToken()}`,
              },
            }
          )
          .then(async (response) => {
            if (
              response.data &&
              response.data.success &&
              response.data.data &&
              response.data.data.length > 0
            ) {
              setCep(response.data.data[0].cep);
              setAddressMapLocation({
                cep: response.data.data[0].cep,
                city: response.data.data[0].city,
                street: response.data.data[0].street,
                district: response.data.data[0].district,
                streetNumber: response.data.data[0].streetNumber,
                state: response.data.data[0].state,
                latLng: {
                  latitude: positionGet.coords.latitude,
                  longitude: positionGet.coords.longitude,
                },
              });

              await getStores(response.data.data[0].cep, {
                latitude: positionGet.coords.latitude,
                longitude: positionGet.coords.longitude,
              });
              if (typeFreight === "delivery" && valueCep) {
                setFreightFind(valueCep);
              }
              setLoading(false);
            } else {
              Swal.fire({
                icon: "error",
                title: "Erro!",
                text: `Impossível recuperar localização do usuário`,
              });
            }
          })
          .catch((e) => {
            setLoading(false);
            Swal.fire({
              icon: "error",
              title: "Erro!",
              text: `Impossível recuperar localização do usuário`,
            });
          });
      },
      () => {
        Swal.fire({
          icon: "warning",
          title: "Atenção!",
          text: "É necessário ativar a localização para usá-la",
        });
      }
    );
  };

  useEffect(() => {
    zerarDiscount();
    loadOrder();
    orderContext.setDiscountGeneral(0);
  }, [totalWithoutDiscount.toString()]);

  async function checkoutAction() {
    try {
      switch (true) {
        case isTable:
          return openModalToSendOrderFood()

        case isCard:
          setTypeModal("Enviar pedido");
          trackInitiateCheckout();
          setOpenModal(true);
          break
        case isLandmark:
          localStorage.removeItem("qrcodePixPayment");
          await continueSynkar();
          break
        case isCounter:
          localStorage.removeItem("qrcodePixPayment");
          await continueCounter();
          break
        case isInternalDelivery:
          localStorage.removeItem("qrcodePixPayment");
          await continueInternalDelivery();
          break
      }
    } catch (error) {

    }
  }

  function checkoutActionTextButton() {
    try {
      switch (true) {
        case isTable:
        case isCard:
          return "Enviar pedido"
        case isLandmark:
        case isCounter:
        case isInternalDelivery:
          return "Continuar para o pagamento"
      }
    } catch (error) {

    }
  }

  return (
    <div className="cart">
      <div className="content-cart">
        {!loadingHeader && (
          <MiniHeader
            name="cart"
            title="Carrinho de compras"
            fontColor={
              config?.webappcolor.fontheader
                ? config.webappcolor.fontheader
                : "#636363"
            }
            backgroundColor={
              config?.webappcolor.backgroundheader
                ? config.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
          />
        )}
        {loading ? (
          <div
            style={{
              width: "100%",
              height: `calc(${loadingHeader ? "100vh" : "100vh - 7em"})`,
            }}
          >
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className="cart-body">
            <div className="cart-items">
              {order &&
                order.products.map((prod) => (
                  <CartItem
                    typePluginspace={typePluginspace}
                    product={prod}
                    key={prod.id}
                    showOutStock={config?.content.pdv.showOutStock}
                    motorTotvs={totvsMotorAble}
                    reloadProducts={async () => await loadOrder()}
                  />
                ))}
            </div>
            <div className="total-value-products">
              <p>Valor total dos produtos</p>
              <p className="price">{floatToPrice(totalWithoutDiscount)}</p>
            </div>
            <div
              className="resume-order"
              style={{
                color: config?.webappcolor.fontinfocart
                  ? config.webappcolor.fontinfocart
                  : "#636363",
              }}
            >
              <h1>Resumo do Pedido</h1>
              <div className="item-resume">
                <p>Subtotal</p>
                <p>{floatToPrice(totalWithoutDiscount)}</p>
              </div>
              <div className="item-resume">
                <p>Desconto</p>
                <p>-{floatToPrice(totalWithoutDiscount - total)}</p>
              </div>
              {!isCard && !isTable && !isCounter && (
                <div className="item-resume">
                  <p>Entrega</p>
                  <p>+{floatToPrice(freightFind)}</p>
                </div>
              )}
              <div className="item-total-resume">
                <p>TOTAL</p>
                <p>{floatToPrice(total + freightFind)}</p>
              </div>
            </div>
            <div className="button-send-order">
              <MainButton
                color={
                  config?.webappcolor.fontbutton
                    ? config.webappcolor.fontbutton
                    : "#636363"
                }
                backgroundColor={
                  config?.webappcolor.webappbutton
                    ? config.webappcolor.webappbutton
                    : "#EAEAEA"
                }
                text={checkoutActionTextButton()}
                onClick={checkoutAction}
              />
            </div>
          </div>
        )}
        {!loadingHeader && (
          <Menu
            activeMenu="cart"
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            hide={hideMenu || sellerModalIsOpen || modalIsOpen}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {modalIsOpen && typeFreight === "delivery" && (
          <ModalDelivery
            isOpen={modalIsOpen}
            setIsOpen={setModalIsOpen}
            backgroundButton={
              config?.webappcolor.webappbutton &&
              config.webappcolor.webappbutton
            }
            fontButton={
              config?.webappcolor.fontbutton && config.webappcolor.fontbutton
            }
            addressMapLocation={addressMapLocation}
          />
        )}
        {modalIsOpen && typeFreight === "withdraw" && (
          <ModalWithdrawal
            isOpen={modalIsOpen}
            setIsOpen={setModalIsOpen}
            backgroundButton={
              config?.webappcolor.webappbutton &&
              config.webappcolor.webappbutton
            }
            fontButton={
              config?.webappcolor.fontbutton && config.webappcolor.fontbutton
            }
            stores={stores}
          />
        )}
        {tableModalIsOpen && (
          <ModalTableSave
            isOpen={tableModalIsOpen}
            setIsOpen={setTableModalIsOpen}
            setLoading={setLoading}
            backgroundButton={
              config?.webappcolor.webappbutton &&
              config.webappcolor.webappbutton
            }
            fontButton={
              config?.webappcolor.fontbutton && config.webappcolor.fontbutton
            }
          />
        )}
        {modalEditFreight && (
          <ModalEditFreight
            isOpen={modalEditFreight}
            setIsOpen={setModalEditFreight}
            setLoading={setLoading}
            backgroundButton={
              config?.webappcolor.webappbutton &&
              config.webappcolor.webappbutton
            }
            fontButton={
              config?.webappcolor.fontbutton && config.webappcolor.fontbutton
            }
            typeFreight={typeFreight}
            valueFreight={typeFreight === "withdraw" ? valueWithDraw : valueCep}
            changeValue={
              typeFreight === "withdraw" ? setValueWithDraw : setValueCep
            }
            newValueFreight={setFreightFind}
          />
        )}
      </div>
    </div>
  );
}
